export const PROCUREMENT_CATEGORY: Record<string, string> = {
    "goods": "Товари",
    "services": "Послуги",
    "works": "Роботи",
};
